const chips = [
  {
    text: 'Ja/nej fråga',
    description: 'Klicka här om du vill skapa ett påstående där svaren ja- eller nej besvaras.',
    href: '/egen-deklaration/checkbox-fraga',
  },
  {
    text: 'Fylla i text',
    description: 'Klicka här om du vill skapa ett fält där text ska fyllas i, av den som blir tattuerad.',
    href: '/egen-deklaration/fylla-text',
  },
  {
    text: 'Endast text',
    description: 'Klicka här om du vill skapa ett fält som endast visar information.',
    href: '/egen-deklaration/endast-text',
  },
];

export default chips;
